import { Box } from '@mui/material';
import type { ReactElement } from 'react';

import { fontStacks } from '../tokens';

/**
 * Touche clavier (maquette « Touche »), dans un champ de recherche, la palette
 * de commandes ou une aide. Element `<kbd>` : un lecteur d'ecran l'annonce comme
 * une saisie au clavier, et non comme un texte ordinaire.
 */
export const Kbd = ({ children }: { readonly children: string }): ReactElement => (
  <Box
    component="kbd"
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      px: 0.75,
      py: '2px',
      borderRadius: '6px',
      border: 1,
      borderColor: 'tokens.border',
      bgcolor: 'tokens.surfaceMuted',
      color: 'tokens.textMuted',
      fontFamily: fontStacks.mono,
      fontSize: 11,
      fontWeight: 700,
      lineHeight: '16px',
      whiteSpace: 'nowrap',
    }}
  >
    {children}
  </Box>
);
